import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

// Menu
export interface MenuSeller {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: MenuSeller[];
}

@Injectable({
	providedIn: 'root'
})

export class NavSellerService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?:any) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: MenuSeller[] = [
		{
			title: 'Dashboard', icon: 'home', type: 'link', badgeType: 'primary',path: '/master/ViewProduct', active: true, 
		},
		/*{
			title: 'Product', icon: 'tag', type: 'sub', badgeType: 'primary', active: false, children: [
				{ path: '/master/AddProductLoc', title: 'Add Product', type: 'link' },				
				{ path: '/master/ViewProduct', title: 'View Product', type: 'link' },				
				{ path: '/master/CollectionsProduct', title: 'Add Collections Product', type: 'link' },							
				{ path: '/master/ProductEnabled', title: 'Enbled Products', type: 'link' },							
				{ path: '/master/ProductDisabled', title: 'Disabled Products', type: 'link' },							
				{ path: '/master/ProductRectification', title: 'Rectification Products', type: 'link' },							
			]
		},
		{
			title: 'Settings', icon: 'settings', type: 'sub', badgeType: 'primary', active: false, children: [
				{ path: '/master/ViewManufacturer', title: 'Manufacturer', type: 'link' },					
			]
		},*/
		{
			title: 'Logout', icon: 'log-out', type: 'link', badgeType: 'primary',path: '/dashboard/Logout', active: false
		}		
	]
	// Array
	items = new BehaviorSubject<MenuSeller[]>(this.MENUITEMS);


}
